import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, XCircle } from 'lucide-react';
const painPoints = [{
  title: 'El dinero se evapora:',
  text: 'Sentís que trabajás todo el día (en casa o afuera) y la plata nunca alcanza para darte un gusto o darles gustos a tus hijos. 🧾'
}, {
  title: 'Miedo a "quemar" ahorros:',
  text: 'Te aterra invertir en insumos, que nadie compre y terminar perdiendo lo poco que tenías guardado. 😰'
}, {
  title: 'Culpa constante:',
  text: 'Si trabajás fuera, no estás nunca en tu casa. Si tenés hijos, los extrañás. Sentís culpa por no generar ingresos propios. Es un callejón sin salida. 💔'
}, {
  title: 'Cansada de improvisar:',
  text: 'Vendés a ojo, cocinás cuando podés y al final del mes te das cuenta de que trabajaste gratis porque calculaste mal los precios. 🚫'
}];
export function Problem() {
  return <section className="py-20 relative overflow-hidden" data-id="element-205">
      {/* Colorful popcorn background */}
      <div className="absolute inset-0 z-0" data-id="element-206">
        <img src="https://images.unsplash.com/photo-1578849278619-e73505e9610f?w=1600&q=80" alt="" className="w-full h-full object-cover" aria-hidden="true" data-id="element-207" />
        <div className="absolute inset-0 bg-white/85 backdrop-blur-sm" data-id="element-208"></div>
      </div>

      <div className="container px-4 mx-auto max-w-3xl relative z-10" data-id="element-209">
        {/* Original text */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12" data-id="element-210">
          <div className="flex justify-center mb-8" data-id="element-211">
            <div className="inline-flex items-center gap-2 bg-palomitas-coral text-white px-5 py-2 rounded-full font-bold text-sm uppercase tracking-wide shadow-lg" data-id="element-212">
              <AlertCircle size={18} data-id="element-213" />
              <span data-id="element-214">⚠️ ¿Te sentís identificado/a?</span>
            </div>
          </div>
          <div className="bg-white/70 backdrop-blur-md rounded-3xl p-8 md:p-12 shadow-xl border border-palomitas-coral/20" data-id="element-215">
            <p className="text-2xl md:text-3xl font-serif text-palomitas-brown leading-relaxed text-center" data-id="element-216">
              "Quizás hoy no llegás a fin de mes o tu trabajo no te gusta.
              Querés usar tu tiempo en generar ingresos extras y aportar en los
              gastos cotidianos con la familia."
            </p>
          </div>
        </motion.div>

        {/* Pain points card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-217">
          <div className="bg-[#f5f3f0] rounded-3xl p-8 md:p-12 shadow-lg" data-id="element-218">
            <h2 className="text-2xl md:text-4xl font-bold text-[#2d3340] text-center mb-10 flex items-center justify-center gap-3" data-id="element-219">
              <span className="text-red-500 text-3xl" data-id="element-220">❗</span>
              La realidad de muchos hoy...
            </h2>

            <div className="space-y-6" data-id="element-221">
              {painPoints.map((point, index) => <motion.div key={index} initial={{
              opacity: 0,
              x: -15
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-4" data-id="element-222">
                  <div className="flex-shrink-0 mt-1" data-id="element-223">
                    <XCircle size={24} className="text-red-500" fill="currentColor" stroke="white" data-id="element-224" />
                  </div>
                  <p className="text-gray-700 text-base md:text-lg leading-relaxed" data-id="element-225">
                    <strong className="text-[#2d3340]" data-id="element-226">{point.title}</strong>{' '}
                    {point.text}
                  </p>
                </motion.div>)}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}